module.exports = __webpack_public_path__ + "img/28.38169197.svg";